import React, { useEffect, useState } from 'react';
import Form1 from './pages/Form1';
import Form2 from './pages/Form2';
import FormEdit from './pages/FormEdit';
import FormPerbaikan from './pages/FormPerbaikan';
import JasaBogaPersyaratan from './pages/JasaBogaPersyaratan';
import FormSuccess from './pages/FormSuccess';
import Navbar from '../../modules/Navbar';
import ProgressBar from '../../modules/ProgressBar';
import Container from '../../modules/Container';

const JasaBoga = () => {
  const [ step, setStep ] = useState(1);
  const [ data, setData ] = useState({});
  const [ isProgressHidden, setIsProgressHidden ] = useState(true);
  const formName = [ 'Pendaftaran', 'Persyaratan', 'Data', 'Selesai' ];
  const components = [ Form1, JasaBogaPersyaratan, Form2, FormSuccess, FormEdit, FormPerbaikan ];

  const nextStep = () => setStep((prevStep) => prevStep + 1);

  const renderComponent = (thisIndex) =>
    components.map((Component, i) => {
      return (
        <Component
          key={ i }
          { ...data }
          setIsProgressHidden={ setIsProgressHidden }
          nextStep={ nextStep }
          setStep={ setStep }
          setData={ setData }
          isShow={ i + 1 === thisIndex ? true : false }
          typeId={ 2 }
        />
      );
    });

  const totalStep = formName.length;

  return (
    <>
      <Navbar />
      <ProgressBar
        isProgressHidden={ isProgressHidden }
        progress={ Math.floor(((step - 1) / (totalStep - 1)) * 100) }
        formName={ formName }
        nowStep={ step <= totalStep ? step : 1 }
        changeStep={ setStep }
      />
      <Container>{renderComponent(step)}</Container>
    </>
  );
};

export default JasaBoga;
